import { As, Box, BoxProps, HStack, Icon, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { ChevronRight } from '../../assets';

export interface StepButtonProps extends BoxProps {
  label?: string;
  iconLeft?: As;
}
/**
 * StepButton is a custom component
 * that been created to reuse for captain tools and message tools.
 * @see https://xd.adobe.com/view/1ce752e2-1b31-478c-b56f-ff11a4cbe4bc-49b4/screen/99f8fbfc-f9a2-48a3-a1d0-f4fa5a212d9e/specs/
 */

export const StepButton: FC<StepButtonProps> = ({
  label = '',
  iconLeft,
  onClick,
  ...rest
}) => (
  <Box
    role="button"
    display="grid"
    alignItems="center"
    border="1px solid var(--chakra-colors-brand-primary-lightGrey)"
    fontWeight="semibold"
    px={4}
    borderRadius="4px"
    onClick={onClick}
    {...rest}
  >
    <HStack justify="space-between" color="brand.additional.link">
      <HStack>
        <Icon as={iconLeft} boxSize="32px" />
        <Text fontSize="md">{label}</Text>
      </HStack>
      <Icon as={ChevronRight} />
    </HStack>
  </Box>
);
